import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import PizzaTypes from "@/pizza-types/pizza-types";
import PizzaTypeDetail from "@/pizza-types/pizza-type-detail";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useLocalization } from "@/context/localization-context";

export default function PizzaTypesPage() {
  const { t } = useLocalization();
  const { pizzaTypeId } = useParams();
  const [selectedPizzaTypeId, setSelectedPizzaTypeId] = useState<string | null>(null);

  useEffect(() => {
    setSelectedPizzaTypeId(pizzaTypeId || null);
  }, [pizzaTypeId]);

  return (
    <div className="app-layout grid grid-cols-1 2xl:grid-cols-1 gap-4 p-4">
      {selectedPizzaTypeId && (
        <PizzaTypeDetail pizzaTypeId={selectedPizzaTypeId} />
      )}
      <div>
        <Card>
          <CardHeader>
            <CardTitle>{t("pizzaTypes.page.title")}</CardTitle>
          </CardHeader>
          <CardContent>
            <PizzaTypes getLink={(pizzaTypeId) => `/pizza-types/${pizzaTypeId}`} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}